export const urlToPath = (url) => {
    if (typeof url !== 'string') url = url.toString();
    const theURL = new URL(url);
    return theURL.pathname;
};

export const arrayToGetString = (key, arr) => {
    let string = '';
    arr.forEach((item) => {
        string = `${string}&${key}[]=${item}`;
    });
    return string;
};

export const shortenUUID = (uuid) => {
    return uuid.slice(0, 8);
};

export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};
